import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppEntry from "./pages";
import MsalInstance from "./authorization/AuthorizationProvider";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from "@azure/msal-browser";
import { store } from "./store";
import "./styles/main.scss";
import { Provider } from "react-redux";

MsalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = MsalInstance.getAllAccounts();
  if (accounts.length > 0) {
    MsalInstance.setActiveAccount(accounts[0]);
  }

  MsalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      MsalInstance.setActiveAccount(account);
    }
  });

  const root = ReactDOM.createRoot(
    document.getElementById("proscan-root") as HTMLElement
  );

  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <AppEntry />
      </Provider>
    </BrowserRouter>
  );
});
